import React from 'react';
import { Outlet } from 'react-router-dom';
import { TeacherProvider } from '../../context/TeacherContext';
import TeacherSidebar from './TeacherSidebar';
import TeacherMobileNavigation from './TeacherMobileNavigation';
import './TeacherLayout.css';

function TeacherLayout() {
  return (
    <TeacherProvider>
      <div className="teacher-layout">
        <TeacherSidebar />
        <main className="teacher-layout__main">
          <Outlet />
        </main>
        <TeacherMobileNavigation />
      </div>
    </TeacherProvider>
  );
}

export default TeacherLayout;
